<template>
  <div class="personnel">
    <u-modal
      v-model="visible"
      :title="title"
      class-name="personnel"
      width="810px"
      @on-ok="ok"
      @on-cancel="cancel"
    >
      <Row :gutter="10">
        <Col span="12">
          <div class="select-box-inner personnel-inner">
            <u-tabs v-model="currentTab" ref="tabs">
              <u-tab-pane label="员工" name="1" v-if="findInTabs('staff')">
                <staff
                  :checked-id="checkedStaffId"
                  @on-change="onStaffChange"
                  :multiple="multiple"
                  ref="staff"
                ></staff>
              </u-tab-pane>
              <u-tab-pane label="职务" name="2" v-if="findInTabs('position')">
                <position
                  :checked-id="checkedPositionId"
                  @on-change="onPositionChange"
                  ref="position"
                ></position>
              </u-tab-pane>
              <u-tab-pane label="部门" name="3" v-if="findInTabs('department')">
                <department
                  :checked-ids="checkedDepartmentId"
                  @on-change="onDepartmentChange"
                  :multiple="multiple"
                  ref="department"
                ></department>
              </u-tab-pane>
              <u-tab-pane label="角色" name="4" v-if="findInTabs('role')">
                <role
                  :checked-id="checkedRoleId"
                  @on-change="onRoleChange"
                  ref="role"
                ></role>
              </u-tab-pane>
            </u-tabs>
          </div>
        </Col>
        <Col span="12">
          <div class="select-box-inner personnel-inner" ref="personnelInner" style="padding: 0;">
            <Collapse
              :value="currentTab"
              @on-change="collapseChange"
              simple
              accordion
              style="height: 100%;"
            >
              <Panel name="1" v-if="findInTabs('staff')">
                已选员工
                <div slot="content" :style="innerStyles">
                  <div
                    v-for="item in checkedStaffList"
                    :key="item.id"
                    class="item-box"
                  >
                    <div class="item-title">{{ item.name }}</div>
                    <div class="item-content">{{ item.positionName }}</div>
                    <div class="item-close" @click="delCheckedStaff(item)">
                      <Icon type="md-close" />
                    </div>
                  </div>
                </div>
              </Panel>
              <Panel name="2" v-if="findInTabs('position')">
                已选职务
                <div slot="content" :style="innerStyles">
                  <div
                    v-for="item in checkedPositionList"
                    :key="item.id"
                    class="item-box"
                  >
                    <div class="item-title">{{ item.title }}</div>
                    <!--<div class="item-content">{{ item.positionName }}</div>-->
                    <div
                      class="item-close"
                      @click="delCheckedPosition(item.nodeKey)"
                    >
                      <Icon type="md-close" />
                    </div>
                  </div>
                </div>
              </Panel>
              <Panel name="3" v-if="findInTabs('department')">
                已选部门
                <div slot="content" :style="innerStyles">
                  <div
                    v-for="item in checkedDepartmentList"
                    :key="item.id"
                    class="item-box"
                  >
                    <div class="item-title">{{ item.title }}</div>
                    <!--<div class="item-content">{{ item.positionName }}</div>-->
                    <div
                      class="item-close"
                      @click="delCheckedDepartment(item)"
                    >
                      <Icon type="md-close" />
                    </div>
                  </div>
                </div>
              </Panel>
              <Panel name="4" v-if="findInTabs('role')">
                已选角色
                <div slot="content" :style="innerStyles">
                  <div
                    v-for="item in checkedRoleList"
                    :key="item.id"
                    class="item-box"
                  >
                    <div class="item-title">{{ item.name }}</div>
                    <div class="item-content">{{ item.roleName }}</div>
                    <div class="item-close" @click="delCheckedRole(item.id)">
                      <Icon type="md-close" />
                    </div>
                  </div>
                </div>
              </Panel>
            </Collapse>
          </div>
        </Col>
      </Row>
    </u-modal>
  </div>
</template>

<script>
import uTabs from "./tabs";
import staff from "@/components/choose-person/staff";
import position from "./position";
import department from "@/components/choose-person/department";
import role from "./role";
// import {oneOf} from "../../utils/tools";
// import { MutationObserver } from "../../utils/assist";
export default {
  name: "personnel",
  props: {
    value: {
      type: Boolean,
      default: true
    },
    tabs: {
      type: Array, //选项框数组 //可选项["staff", "position", "department", "role"]
      default: () => []
    },
    title: {
      type: String,
      default: "选择员工"
    },
    multiple: {
      type: Boolean,
      default: true
    },
    staffCheckedId: {
      type: Array,
      default: () => []
    },
    positionCheckedId: {
      type: Array,
      default: () => []
    },
    departmentCheckedId: {
      type: Array,
      default: () => []
    },
    roleCheckedId: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    this.calHeight();
    // const hiddenParentNode = this.isInsideHiddenElement();
    // console.log(hiddenParentNode);
    // if (hiddenParentNode) {
    //   this.mutationObserver = new MutationObserver(() => {
    //     if (hiddenParentNode.style.display !== "none") {
    //       // this.updateBar();
    //       console.log("计算");
    //       this.mutationObserver.disconnect();
    //     }
    //   });
    //   this.mutationObserver.observe(hiddenParentNode, { attributes: true, childList: true, characterData: true, attributeFilter: ['style'] });
    // }
    // this.calHeight();
    this.currentTab = this.$refs.tabs.activeKey;
  },
  data() {
    return {
      visible: this.value,
      currentTab: "",
      innerMaxHeight: 0,
      checkedStaffId: this.staffCheckedId, //已选员工id
      checkedStaffList: [], //已选员工列表
      checkedPositionId: this.positionCheckedId, //已选职务id
      checkedPositionList: [], //已选职务列表
      checkedRoleList: [], //已选角色列表
      checkedRoleId: this.roleCheckedId, //已选角色id,
      checkedDepartmentId: this.departmentCheckedId, //已选部门id
      checkedDepartmentList: [] //已选部门列表
    };
  },
  methods: {
    onStaffChange(checkList) {
      // this.checkedStaffList= [];
      // checkList.forEach(item => {
      //   this.checkedStaffList.push(item.name);
      // })
      this.checkedStaffList = checkList;
      // this.checkedStaffId = checkedId;
    },
    delCheckedStaff(node) {
      this.$refs.staff.del(node);
    },
    onPositionChange(checkList) {
      this.checkedPositionList = checkList;
      // this.checkedPositionId = checkedId;
    },
    delCheckedPosition(nodekey) {
      this.$refs.position.delChecked(nodekey);
    },
    onDepartmentChange(checkList) {
      console.log(checkList);
      this.checkedDepartmentList = checkList;
      // this.checkedDepartmentId = checkedId;
    },
    delCheckedDepartment(node) {
      this.$refs.department.del(node);
    },
    onRoleChange(checkList) {
      this.checkedRoleList = checkList;
      // this.checkedRoleId = checkedId;
    },
    delCheckedRole(nodekey) {
      this.$refs.role.delChecked(nodekey);
    },
    calHeight() {
      //动态计算 personnelInner 高度
      let el = this.$refs.personnelInner;
      let count = this.tabs.length;
      //2 为上线边框宽度  39*4为Panel高度乘以数量 16为padding-bottom
      this.$nextTick(() => {
        this.innerMaxHeight = el.offsetHeight - 2 - 39 * count - 16;
      });
    },
    findInTabs(tab) {
      return this.tabs.includes(tab);
    },
    ok() {
      let checkedData = {
        checkedStaffList: this.checkedStaffList,
        checkedPositionList: this.checkedPositionList,
        checkedDepartmentList: this.checkedDepartmentList,
        checkedRoleList: this.checkedRoleList
      };
      this.$emit("on-ok", checkedData);
      this.close();
      // this.$Message.info("Clicked ok");
    },
    cancel() {
      //todo onCancel 需要改为on-cancel 引用的地方太多. 目前没法改
      this.$emit("onCancel");
      this.close();
      // this.$Message.info("Clicked cancel");
    },
    close() {
      this.visible = false;
      this.$emit("input", false);
    },
    collapseChange(keyArr) {
      let key = keyArr[0];
      if (key && key !== this.currentTab) {
        this.currentTab = keyArr[0];
      }
    },
    // isInsideHiddenElement() {
    //   // todo 为正确找到parentNode
    //   let parentNode = this.$el.parentNode;
    //   while (parentNode && parentNode !== document.body) {
    //     if (parentNode.style && parentNode.style.display === "none") {
    //       return parentNode;
    //     }
    //     parentNode = parentNode.parentNode;
    //   }
    //   return false;
    // }
  },
  computed: {
    innerStyles() {
      return {
        maxHeight: this.innerMaxHeight + "px",
        overflow: "auto"
      };
    }
  },
  watch: {
    staffCheckedId: {
      handler(val) {
        this.checkedStaffId = val;
      }
    },
    departmentCheckedId: {
      handler(val) {
        this.checkedDepartmentId = val;
      }
    },
    roleCheckedId: {
      handler(val) {
        // console.log(val);
        this.checkedRoleId = val;
      }
    },
    value(val) {
      this.calHeight();
      this.visible = val;
    }
  },
  components: {
    uTabs,
    uTabPane: uTabs.Pane,
    staff,
    position,
    department,
    role
  }
};
</script>

<style scoped></style>
